module.exports = __webpack_public_path__ + "media/img/pages/companies/inventx-7a343fa2460b7c3643473b22bc33b613.png";